/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ExternalParkingSessionDto { 
    trackingId?: string;
    startDateTime?: string;
    endDateTime?: string;
    vehicleRegistrationNo?: string | null;
    locationCode?: string | null;
    transactionId?: string | null;
}

